import { connect } from 'react-redux';
import { getIsMobileSearchParam } from '@wix/communities-blog-client-common';

export default function withDeviceType(WrappedComponent) {
  const mapStateToProps = (state) => {
    const isMobile = getIsMobileSearchParam(state);
    return {
      isMobile,
      isDesktop: !isMobile,
    };
  };

  return connect(mapStateToProps)(WrappedComponent);
}
